import SelectSearch from 'react-select-search/dist/cjs/SelectSearch';
import styled from 'styled-components';

const Separator = styled.hr`
	margin: 30px 0;
	border: 0;
	border-bottom: 1px solid #ccc;
`

export default Separator